import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { bonuses } from '../data/content';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './CtaButton';
export function Bonuses() {
  return <section className="bg-navyDeep py-16 sm:py-24" data-id="element-45" data-mp="aua4y8rf39qx">
      <div className="mx-auto max-w-6xl px-4" data-id="element-46" data-mp="ftwkwpymr43f">
        <SectionHeading tone="dark" eyebrow="Your Five Exclusive Bonuses" title="5 Professional Resources Included FREE With Your Purchase" intro="I’ve created five additional resources to help you study, organize, and review third molar assessment concepts." data-id="element-47" data-mp="fslh4q56pwcb" />

        <div className="mt-12 space-y-14 sm:space-y-20" data-id="element-48" data-mp="3o3fys1kz95lf">
          {bonuses.map((b, i) => <article key={b.number} className="grid items-center gap-6 lg:grid-cols-2 lg:gap-12" data-id="element-49" data-mp="3t0yc046126z8" data-mpi={i}>
              <div className={`-mx-4 sm:mx-0 ${i % 2 === 1 ? 'lg:order-2' : ''}`} data-id="element-50" data-mp="1mb1l5epgunat">
                <img src={b.image} alt={`Bonus #${b.number}: ${b.title}`} className="w-full bg-white sm:rounded-3xl" loading="lazy" data-id="element-51" data-mp="1r80fnyd1kw9j" />
              </div>

              <div data-id="element-52" data-mp="3ddioyq5p7ayt">
                <div className="flex flex-wrap items-center gap-2" data-id="element-53" data-mp="3r79qpcd6tqjz">
                  <span className="inline-flex items-center gap-1.5 rounded-md bg-gold px-2.5 py-1 text-xs font-extrabold uppercase tracking-wider text-ink" data-id="element-54" data-mp="3r8ku3b2q0wak">
                    <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-55" data-mp="2zgddgan7tjw6" />
                    Bonus #{b.number}
                  </span>
                  <span className="text-sm font-semibold text-white/70" data-id="element-56" data-mp="2uik5pd69khts">
                    Reference value: <span className="line-through" data-id="element-57" data-mp="38e5txi4oaxl5">${b.value}</span>{' '}
                    <span className="font-extrabold text-cta" data-id="element-58" data-mp="33ge4qvvexpkn">— Included FREE</span>
                  </span>
                </div>
                <h3 className="mt-3 font-display text-2xl font-bold leading-tight text-white sm:text-3xl" data-id="element-59" data-mp="ns49s7l5i48r">{b.title}</h3>
                <div className="mt-4 space-y-3 text-[15px] leading-relaxed text-white/80" data-id="element-60" data-mp="3ciwqenh6xfi3">
                  {b.intro.map(p => <p key={p} data-id="element-61" data-mp="3hgy9v9ij3gu3">{p}</p>)}
                </div>
                <p className="mt-5 text-xs font-bold uppercase tracking-[0.14em] text-sky" data-id="element-62" data-mp="3lj3161li81dk">{b.listTitle}</p>
                <ul className="mt-3 grid gap-2 sm:grid-cols-2 sm:gap-x-6" data-id="element-63" data-mp="3qj7g3n6rko1o">
                  {b.items.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] leading-relaxed text-white" data-id="element-64" data-mp="2ttq4krl3o7s2">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-65" data-mp="2xujqxgiw9eiu" />
                      {item}
                    </li>)}
                </ul>
                <p className="mt-5 border-t border-white/10 pt-4 text-xs leading-relaxed text-white/60" data-id="element-66" data-mp="37klem77c4ux8">{b.note}</p>
              </div>
            </article>)}
        </div>

        <div className="mt-14" data-id="element-67" data-mp="2f2h7jxevbk4w">
          <CtaButton tone="dark" label="Yes, I Want All 5 Bonuses" data-id="element-68" data-mp="2f1pplpe71kx3" />
        </div>
      </div>
    </section>;
}